<template>
  <div ref="inputbox">
    <!-- date -->
    <b-form-group v-if="type === 'date'">
      <div class="d-flex align-items-center">
        <!-- display value -->
        <label class="sr__value" style="width: 90%;">
          <span v-if="!editing">
            <span
              v-for="(item, index) in displayStrinValues"
              :key="`ds-${index}`"
              :class="getDisplayStringValueClass(item)"
            >{{item.value.trim()}}</span>
          </span>
        </label>

        <!-- edit button -->
        <div
          style="width: 10%; text-align:center"
          @click="editDiff"
          v-if="!editing && !disable"
        >
          <b-icon class="sr__icon sr__icon--cricle" icon="arrow-right-short"></b-icon>
        </div>
      </div>

      <!-- input -->
      <div class="d-flex align-items-center">
        <div style="width: 90%;" v-if="editing">
          <b-form-datepicker
            v-if="editing"
            v-model="value"
            class="sr__input sr__datepicker"
            :class="{'sr__input--invalid': !this.valid}"
            placeholder="請選擇日期"
          ></b-form-datepicker>
        </div>

        <!-- edit button -->
        <div
          v-if="editing && valid"
          style="width: 10%; text-align:center"
          @click="editDiff"
          :disabled="!valid"
        >
          <b-icon class="sr__icon sr__icon--cricle" icon="arrow-left-short"></b-icon>
        </div>
      </div>
    </b-form-group>

    <!-- string -->
    <b-form-group v-else>
      <div class="d-flex align-items-center">
        <!-- display value -->
        <label style="width: 90%;" class="sr__value">
          <span v-if="!editing">
            <span
              v-for="(item, index) in displayStrinValues"
              :key="`ds-${index}`"
              :class="getDisplayStringValueClass(item)"
            >{{item.value.trim()}}</span>
          </span>
        </label>

        <!-- edit button -->
        <div
          style="width: 10%; text-align:center"
          @click="editDiff"
          v-if="!editing && !disable"
        >
          <b-icon class="sr__icon sr__icon--cricle" icon="arrow-right-short"></b-icon>
        </div>
      </div>

      <!-- input -->
      <div class="d-flex align-items-center">
        <div style="width: 90%;" v-if="editing">
          <b-form-input
            class="sr__input"
            :class="{'sr__input--invalid': !valid}"
            v-model="value"
          ></b-form-input>
        </div>

        <!-- edit button -->
        <div
          v-if="editing && valid"
          style="width: 10%; text-align:center"
          @click="editDiff"
          :disabled="!valid"
        >
          <b-icon class="sr__icon sr__icon--cricle" icon="arrow-left-short"></b-icon>
        </div>
      </div>

    </b-form-group>

    <b-form-invalid-feedback :state="valid">
      {{invalidMsg}}
    </b-form-invalid-feedback>
  </div>
</template>

<script>
const Diff = require('diff')

export default {
  name: 'DiffValueItem',
  props: {
    field: Object,
    disable: Boolean
  },
  data () {
    return {
      value: '',
      originalValue: '',
      displayStrinValues: [],
      type: '',
      editing: false,
      valid: true,
      invalidMsg: ''
    }
  },
  watch: {
    value () {
      this.checkValueIsValid()
      var tmpValue = Diff.diffChars(this.originalValue, this.value)
      if (!this.isStringType) {
        tmpValue = tmpValue.filter(e => !e.removed)
      }
      this.displayStrinValues = tmpValue

      this.field.value.edit_value = this.value
    }
  },
  computed: {
    isStringType () {
      return this.type === 'string'
    }
  },
  methods: {
    isDateValid (dateStr) {
      return !isNaN(new Date(dateStr))
    },
    isValid () {
      if (this.isStringType) {
        return !!this.value
      } else {
        return this.isDateValid(this.value)
      }
    },
    getDisplayStringValueClass (item) {
      if (item.added) {
        return 'added'
      } else if (item.removed) {
        return 'removed'
      }

      return ''
    },
    editDiff () {
      this.editing = !this.editing
    },
    checkValueIsValid (uiNotify = true) {
      if (this._isDestroyed) {
        this.valid = true
        this.invalidMsg = ''
        return true
      }

      if (!this.isValid()) {
        if (!uiNotify) {
          return false
        }

        this.editing = true
        this.valid = false
        this.invalidMsg = '欄位必填'
      } else {
        this.valid = true
        this.invalidMsg = ''
      }

      return this.valid
    }
  },
  created () {
    this.originalValue = this.field.value.original_value
    this.value = this.field.value.edit_value || this.originalValue
    this.type = this.field.value.type
  },
  mounted () {
    var top = this.$refs.inputbox.getBoundingClientRect().top

    this.$store.dispatch('pushValidateInfo', {
      id: this._uid,
      top: () => { return top },
      checkValueIsValid: this.checkValueIsValid
    })
  }
}
</script>

<style scoped>
  .added {
    color: green;
  }

  .removed {
    color: red;
    text-decoration: line-through;
  }
</style>
